import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  documents: [],
  applicationId: null,
  applicationType: '',
};

// eslint-disable-next-line consistent-return
export default function instantServicesReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.INSTANT_SERVICE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.INSTANT_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.INSTANT_SERVICE_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action, 'payload', null),
      };
    case types.INSTANT_SERVICE_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    case types.INSTANT_SERVICE_CLEAR_APPLICATION:
      return {
        ...defaultState,
      };
    case types.INSTANT_SERVICE_CHANGE_WORKFLOW_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };
    case types.INSTANT_SERVICE_FETCH_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        application: get(action.payload, 'application', {}),
      };
    case types.INSTANT_SERVICE_FETCH_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };
    default:
      return state;
  }
}
